module.exports = __webpack_public_path__ + "img/slider_emt2.6bfc93a6.png";